import { useRouter } from 'next/router';
import { ReactElement, useRef } from 'react';

import {
  TimelineAlerts,
  TimelineHeader,
  TimelineOperations,
} from '@/modules/home';
import { TAB_QUERY_INDICATOR } from '@/modules/home/components/TimeLine/TimelineHeader';

export default function TimeLine(): ReactElement {
  const { query } = useRouter();
  const parentScrollRef = useRef<HTMLDivElement>(null);

  const selectedTab = query?.[TAB_QUERY_INDICATOR] as
    | 'operations'
    | 'alerts'
    | undefined;
  return (
    <section className='col-span-6 rounded-2xl bg-background-neutral-99 tablet:sticky tablet:top-[15vh] tablet:z-10 tablet:col-span-2 tablet:h-[calc(78vh-24px)]'>
      <TimelineHeader />
      <div
        ref={parentScrollRef}
        className='h-[67vh] overflow-auto scrollbar-thin scrollbar-thumb-background-400 scrollbar-h-1'
      >
        {
          {
            operations: <TimelineOperations ref={parentScrollRef} />,
            alerts: <TimelineAlerts />,
          }[selectedTab || 'operations']
        }
      </div>
    </section>
  );
}
export { TimeLine };
